import { addNotification, getSessionSaga, reduceLoading } from 'metrix-common3';
import { call, put } from 'redux-saga/effects';
import { reduceCancellationResult } from '../../actions/policy/reduceCancellationResult';
import { getPolicySaga } from './getPolicySaga';
import { getPolicySummarySaga } from './getPolicySummarySaga';

export function* completeCancellationSaga(action) {
    try {
        yield put(reduceLoading({ code: 'completeCancellation', value: true }));
        const session = yield getSessionSaga();

        const response = yield call(fetch, '/api/policyCancellation/complete', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                policyTransactionGuid: action.payload.policyTransactionGuid,
                refundMethod: action.payload.refundMethod,
                refundReference: action.payload.refundReference,
                refundDate: action.payload.refundDate,
            }),
        });

        const result = yield call([response, 'json']);
        yield put(reduceCancellationResult(result));
        yield put(reduceLoading({ code: 'completeCancellation', value: false }));

        if (result.operation?.status) {
            yield put(
                addNotification({
                    code: 'completeCancellation',
                    type: 'success',
                    message: action.payload.successMessage,
                }),
            );
            // Finalized - refresh in place so the transaction reflects the terminal Cancelled status.
            yield getPolicySaga();
            yield getPolicySummarySaga();
        } else {
            yield put(
                addNotification({
                    code: 'completeCancellation',
                    type: 'error',
                    errors: result.operation?.errors,
                    message: action.payload.errorMessage,
                }),
            );
        }
    } catch (error) {
        console.log('Error while completing Cancellation API - ', error);
        yield put(reduceLoading({ code: 'completeCancellation', value: false }));
        yield put(
            addNotification({
                code: 'completeCancellation',
                type: 'error',
                message: action.payload.errorMessage,
            }),
        );
    }
}
